function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { usePromptSuggestions } from "../../../../hooks/reactQuery/queries/usePromptSuggestions";
const TYPEWRITER_INTERVAL_MS = 25;
const VISIBLE_DURATION_MS = 3000;
const FADE_DURATION_MS = 500;
export const useAnimatedPlaceholder = (disabled, isLoading, value) => {
  const {
    suggestions
  } = usePromptSuggestions();
  const [placeholderState, setPlaceholderState] = useState({
    currentSuggestionIndex: 0,
    displayedText: '',
    isTyping: true,
    opacity: 1
  });
  useEffect(() => {
    if (disabled || isLoading || value || suggestions.length === 0) {
      setPlaceholderState({
        currentSuggestionIndex: 0,
        displayedText: '',
        isTyping: false,
        opacity: 0
      });
      return;
    }
    let timeoutId;
    let typingTimeoutId;
    let fadeTimeoutId;
    const currentSuggestion = suggestions[placeholderState.currentSuggestionIndex];
    let charIndex = 0;
    const typeNextChar = () => {
      if (charIndex < currentSuggestion.length) {
        setPlaceholderState(prev => _objectSpread(_objectSpread({}, prev), {}, {
          displayedText: currentSuggestion.slice(0, charIndex + 1)
        }));
        charIndex++;
        typingTimeoutId = setTimeout(typeNextChar, TYPEWRITER_INTERVAL_MS);
      } else {
        setPlaceholderState(prev => _objectSpread(_objectSpread({}, prev), {}, {
          isTyping: false
        }));
        timeoutId = setTimeout(() => {
          setPlaceholderState(prev => _objectSpread(_objectSpread({}, prev), {}, {
            opacity: 0
          }));
          fadeTimeoutId = setTimeout(() => {
            setPlaceholderState(prev => ({
              currentSuggestionIndex: (prev.currentSuggestionIndex + 1) % suggestions.length,
              displayedText: '',
              isTyping: true,
              opacity: 1
            }));
          }, FADE_DURATION_MS);
        }, VISIBLE_DURATION_MS);
      }
    };
    setPlaceholderState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      opacity: 1,
      isTyping: true,
      displayedText: ''
    }));
    typeNextChar();
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(typingTimeoutId);
      clearTimeout(fadeTimeoutId);
    };
  }, [disabled, isLoading, value, placeholderState.currentSuggestionIndex, suggestions]);
  return {
    displayedText: placeholderState.displayedText,
    isTyping: placeholderState.isTyping,
    opacity: placeholderState.opacity,
    duration: FADE_DURATION_MS / 1000
  };
};